<div class="internal-layout-container">
  <app-sidebar-navigation
    [userInfo]="userInfo$ | async"
    [jobsPanelOpen]="jobsPanelOpen"
    (jobsPanelToggle)="toggleJobsPanel()"
  ></app-sidebar-navigation>

  <div class="main-content-area">
    <app-header
      [title]="headerText$ | async"
      [isRefreshing]="!!(isRefreshing$ | async)"
      [syncIndicators]="syncIndicators"
      [cacheLastUpdated]="formattedLastUpdated$ | async"
    >
      <navbar-action-buttons
        class="flex items-center justify-end gap-2 sm:gap-4 lg:gap-6 text-base"
      ></navbar-action-buttons>
    </app-header>
    <main>
      @if (userData$ | async) {
        <router-outlet></router-outlet>
      } @else {
        <div class="flex items-center justify-center h-full">
          <mat-spinner [diameter]="48"></mat-spinner>
        </div>
      }
    </main>

    <!-- Jobs Panel -->
    <div *ngIf="jobsPanelOpen" class="jobs-panel-wrapper">
      <app-jobs-panel (closePanel)="closeJobsPanel()"></app-jobs-panel>
    </div>
  </div>
  <cdw-ae-spog-footer [licenseExpiry]="licenseExpiry()"></cdw-ae-spog-footer>
</div>
